module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0116.png.a3b9ea66.jpg";